import axios from "axios";

/**
 * Create a separate axios instance for public endpoints
 * This instance does NOT redirect to login on 401/422 errors
 */
const publicRequest = axios.create();

/**
 * Get data from public endpoints (no auth required)
 * Does not redirect to login on authentication errors
 */
export function getPublicData(url: string) {
  return publicRequest.get(url);
}